import React, { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PayPal from "../paypal/index";
import Razorpay from "../razorpay";
import OrderService from "../../services/OrderService";
import { DishContext } from "../../providers/DishProvider";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill1, faCreditCard } from "@fortawesome/free-solid-svg-icons";
import {
  LeftSection,
  RightSection,
  MiddleDetails,
  RightContainer,
  CheckoutContainer,
  RadioButtonContainer,
  DetailContainer,
  DetailSubContainer,
  Label,
  LeftDetails,
  RightDetails
} from "./StyledCheckout";
const Title = styled.span``;
const DishQnty = styled.div`
  font-size: 20px;
  font-weight: 150;
`;
const Summary = styled.div`
  flex: 1;
  border: 0.5px solid lightgray;
  border-radius: 10px;
  padding: 20px;
`;
const OrderTitle = styled.h3`
  font-weight: 500;
`;
const Button = styled.button`
  width: 100%;
  padding: 10px;
  background-color: black;
  color: white;
  font-weight: 600;
`;
const OrderText = styled.span``;
export const Circle = styled.span`
  display:inline-block;
  width: 16px;
  height: 16px;
  border: 3px solid ;
  border-color: orange ;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
  transition: border-color 0.3s;
   &:after {
    content: '';
    display: ${(props) => (props.selected ? 'block' : 'none')};
    width: 8px;
    height: 8px;
    background-color: orange;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  } 
    &:hover:before {
    background-color: orange;
    cursor: pointer;
  }`;
const PaymentMethodContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  border: 2px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 10px;
  transition: border 0.3s, transform 0.3s;
  ${(props) =>
    props.selected &&
    `
    border-color: blue;
    transform: scale(1.06); 
  `}
`;
function Checkout() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState();
  const [paymentMethod, setPaymentMethod] = useState();

  const location = useLocation();
  const value = useContext(DishContext);
  const [cart, setCart] = value.cart;
  const currency = value.currency;
  const [selectedBtn, setSelectedBtn] = useState();
  const navigate = useNavigate();
  
  useEffect(() => {
    const getData = () => {
      setData(location.state);
    };
    getData();
  }, [location.state]);
  useEffect(() => {
    const getTotal = () => {
      const item = data;
      const res = item.reduce((prev, item) => {
        return prev + item.price * item.count;
      }, 0);
      setTotal(res);
    };
    getTotal();
  }, [data]);
  const saveOrder = (data, currency) => {
    const orderData = {};
    orderData.payment = { id: " ", method: paymentMethod };
    orderData.data = data;
    orderData.currency = currency;
    console.log("Order data before saving", orderData);
    OrderService.saveOrders(orderData).then(() => {
      setCart([]);
    });
  };
  const onRadioChange = (e) => {
    setSelectedBtn(e.target.value);
    setPaymentMethod(e.target.value);
  };

  const handlePlaceOrder = () => {
   
  
    saveOrder(data, currency);
    navigate("/my-orders");
  };
  return (
    <div>
      <CheckoutContainer>
        <LeftSection>
          {data.map(order => (
            <DetailContainer key={order._id}>
              <DetailSubContainer>
                <LeftDetails>
                  <li>
                    <Title>
                      <b>Dish Name: </b>
                      {order.title}
                    </Title>
                  </li>
                  <li>
                    <Title>
                      <b>Dish Price: </b>{currency} {order.price}
                    </Title>
                  </li>
                  <li>
                    <Title>
                      <b>Address: </b>
                      {order.address}
                    </Title>
                  </li>
                  <li>
                    <Title>
                      <b>Contact :</b>
                      {order.chef.phoneNumber}
                    </Title>
                  </li>
                  <li>
                    <Title>
                      <b>Delivery :</b>
                      {order.deliveryMode}
                    </Title>
                  </li>
                </LeftDetails>
                <MiddleDetails>
                  <li>
                    <DishQnty>Qty :{order.count}</DishQnty>
                  </li>
                </MiddleDetails>
                <RightDetails>
                  <li>
                    <DishQnty>Price:{currency}{order.price}</DishQnty>
                  </li>
                 
                </RightDetails>
              </DetailSubContainer>
              <hr />
            </DetailContainer>
          ))}
          <DetailContainer>
          
            <OrderText>
             <b>Total Payment: {currency} {total} </b>
              </OrderText>
             
              </DetailContainer>
        </LeftSection>
        <RightSection>
          <Summary>
            <RightContainer>
              <OrderTitle style={{ color: "#87CEEB", font:"status-bar", fontSize:"20px"}}> 
                <b>
                  SELECT PAYMENT METHOD
                  </b>
                  </OrderTitle>
                  { value.country !== "India" &&(
               <PaymentMethodContainer
                selected={selectedBtn === "paypal"}
                onClick={() => onRadioChange({ target: { value: "paypal" } })}>
                <Label>
                  <input
                    type="radio"
                    name="radio1"
                    value="paypal"
                    onChange={onRadioChange}
                    style={{ display: "none",color:"orange" }}
                  />
                  {/* <Circle /> */}
                  <Circle selected={selectedBtn === "paypal"} />
                  <OrderTitle>
                    <FontAwesomeIcon
                      icon={faCreditCard}
                      style={{ color: "#63E6BE", marginRight: '8px' }}
                    />
                    Debit and Credit Card
                  </OrderTitle>
                </Label>
              </PaymentMethodContainer>
                  )}
              <PaymentMethodContainer
                selected={selectedBtn === "razorpay"}
                onClick={() => onRadioChange({ target: { value: "razorpay" } })}>
                <Label>
                  <input
                    type="radio"
                    name="radio1"
                    value="razorpay"
                    onChange={onRadioChange}
                    style={{ display: "none" }}
                  />
                  {/* <Circle /> */}
                  <Circle selected={selectedBtn === "razorpay"} />
                  <OrderTitle>RazorPay</OrderTitle>
                </Label>
              </PaymentMethodContainer>
              <PaymentMethodContainer
                selected={selectedBtn === "cash"}
                onClick={() => onRadioChange({ target: { value: "cash" } })}>
                <Label>
                  <input
                    type="radio"
                    name="radio1"
                    value="cash"
                    onChange={onRadioChange}
                    style={{ display: "none" }}
                  />
                              <Circle selected={selectedBtn === "cash"} />
                  <OrderTitle>
                    <FontAwesomeIcon
                      icon={faMoneyBill1}
                      style={{ color: "#63E6BE", marginRight: '8px' }}
                    />
                    Cash
                  </OrderTitle>
                </Label>
              </PaymentMethodContainer> 
              <OrderText>
                <b>Total Payment:</b>{currency} {total}
              </OrderText>
              <OrderTitle>
                <b>Payment Method:</b>
                {paymentMethod}
              </OrderTitle>
              {paymentMethod === "paypal" && (
                <PayPal datas={data} total={total} currency_type={currency} />
              )}
              {/* {paymentMethod === "cash" && (
                <Button onClick={() => saveOrder(data, currency)}>Place Order</Button>
                
              )} */}
              {paymentMethod === "cash" && (
                   <Button onClick={handlePlaceOrder}>Place Order</Button>
               )}
              {paymentMethod === "razorpay" && (
                <Razorpay datas={data} total={total} currency_type={currency} />
              )}
            </RightContainer>
          </Summary>
        </RightSection>
      </CheckoutContainer>
    </div>
  );
}
export default Checkout;
